import badWordsList from '../karaliste.json';

// Kötü sözleri bir Set'e dönüştür
const badWordsSet = new Set(badWordsList.map((word) => word.toLowerCase()));

// Metni temizleme ve normalleştirme fonksiyonu
const normalizeText = (text) => {
    if (!text || typeof text !== 'string') return '';

    // Metni küçük harfe çevir
    let normalized = text.toLowerCase();

    // Özel karakterleri, sembolleri ve boşlukları temizle
    // Örneğin: #kötüsöz -> kötüsöz, kötü-söz -> kötüsöz, kötü söz -> kötüsöz
    normalized = normalized
        .replace(/[^a-zA-Z0-9ğüşıöç\s]/g, '') // Özel karakterleri kaldır
        .replace(/\s+/g, ''); // Boşlukları kaldır

    return normalized;
};

// Kötü söz kontrolü yapan fonksiyon
export const checkForBadWords = (text) => {
    if (!text || typeof text !== 'string') {
        return { isProfane: false, probability: 0 };
    }

    // Metni normalleştir
    const normalizedText = normalizeText(text);

    // Normal metni kelimelere ayır (eğer boşluklar varsa)
    const words = text.toLowerCase().split(/\s+/);

    // Normalleştirilmiş metni kontrol et
    const isProfaneInNormalized = badWordsSet.has(normalizedText);

    // Tek tek kelimeleri kontrol et
    const isProfaneInWords = words.some((word) => {
        const cleanedWord = normalizeText(word);
        return badWordsSet.has(cleanedWord);
    });

    // Orijinal metni de kontrol et (bazı durumlarda normalizasyon sonrası anlam kaybolabilir)
    const isProfaneInOriginal = words.some((word) => badWordsSet.has(word.toLowerCase()));

    // Herhangi birinde kötü söz varsa true döndür
    const isProfane = isProfaneInNormalized || isProfaneInWords || isProfaneInOriginal;

    return {
        isProfane,
        probability: isProfane ? 0.9 : 0,
    };
};

// Mevcut bileşenlerle uyumlu bir containsBadWord fonksiyonu
export const containsBadWord = (text) => {
    const { isProfane } = checkForBadWords(text);
    return isProfane;
};